"use client"

import Image, { ImageLoader } from "next/image"

import { classNames } from "@punks/ui-core"
import { useNextSanityImage } from "next-sanity-image"
import { client } from "../../../../root/contents/sanity/lib/client"

const DEFAULT_IMAGE_SIZES = "(max-width: 768px) 80vw, 1024px"

// const isVectorial = (src: string) => src.toLowerCase().endsWith(".svg")

const parseSize = (size: string) => {
  if (!size.includes("x")) {
    return undefined
  }
  const width = parseInt(size.split("x")[0])
  const height = parseInt(size.split("x")[1])

  if (!isNaN(width) && !isNaN(height) && height) {
    return {
      width,
      height,
    }
  }
}

const calculateAspectRatio = (width: number, height: number) => {
  return height / width
}

const calculateHeightOnAspectRatio = (width: number, aspectRatio: number) => {
  return width * aspectRatio
}

const calculateWidthOnAspectRatio = (height: number, aspectRatio: number) => {
  return height / aspectRatio
}

const calculateImageSize = (
  originalSize: { width: number; height: number },
  containerSize: { width?: number; height?: number }
) => {
  if (containerSize.width && !containerSize.height) {
    const aspectRatio = calculateAspectRatio(
      originalSize.width,
      originalSize.height
    )
    const height = calculateHeightOnAspectRatio(
      containerSize.width,
      aspectRatio
    )
    return {
      width: containerSize.width,
      height,
    }
  }

  if (!containerSize.width && containerSize.height) {
    const aspectRatio = calculateAspectRatio(
      originalSize.width,
      originalSize.height
    )
    const width = calculateWidthOnAspectRatio(containerSize.height, aspectRatio)
    return {
      width,
      height: containerSize.height,
    }
  }

  return originalSize
}

export interface ImageFieldProps {
  asset?: any
  responsive?: boolean
  width?: number | string
  height?: number | string
  objectFit?: "cover" | "contain"
  objectPosition?: string
  priority?: boolean
  style?: React.CSSProperties
  sizes?: string
  fill?: "height" | "width"
  className?: string
}

const SanityImageField = ({
  asset,
  responsive,
  height,
  width,
  objectFit,
  objectPosition,
  priority,
  style,
  sizes,
  fill,
  className,
}: ImageFieldProps) => {
  const imageProps = useNextSanityImage(client, asset)

  if (!asset) {
    return <></>
  }

  // TODO: SIMO: refactor this component
  const {
    width: defaultWidth,
    height: defaultHeight,
    ...other
  } = imageProps ?? ({} as any)

  const imgProps = {
    ...other,
    priority,
  }

  const imgStyle = {
    objectFit,
    objectPosition,
  }

  if (responsive) {
    return (
      <div
        className="relative h-full"
        style={{
          // width,
          // height,
          ...style,
        }}
      >
        <Image
          sizes={sizes ?? DEFAULT_IMAGE_SIZES}
          {...imgProps}
          fill
          alt={asset?.alt ?? ""}
          style={imgStyle}
          className={className}
        />
      </div>
    )
  }

  const imgWidth = width ?? defaultWidth
  const imgHeight = height ?? defaultHeight

  const size = { height: defaultHeight, width: defaultWidth }

  return (
    <Image
      sizes={sizes ?? DEFAULT_IMAGE_SIZES}
      {...imgProps}
      {...(size && typeof imgWidth !== "number" && typeof imgHeight !== "number"
        ? calculateImageSize(size, {
            height: typeof imgHeight === "number" ? imgHeight : undefined,
            width: typeof imgWidth === "number" ? imgWidth : undefined,
          })
        : {
            height: typeof imgHeight === "number" ? imgHeight : 100,
            width: typeof imgWidth === "number" ? imgWidth : 100,
          })}
      alt={asset?.alt ?? ""}
      style={imgStyle}
      className={classNames(
        {
          "h-full w-auto": fill === "height",
          "w-full h-auto": fill === "width",
        },
        className
      )}
    />
  )
}

export default SanityImageField
